import axiosInstance from 'api/axiosInstance'
import { type UserNote } from 'components/UI/Modal/UserDetails/UserDetails'
import { type NewNote } from 'components-ref/organisms'
import {
    type ImageAndCropImage,
    type SubscribePayload
} from 'types/api/profile'
import { type ITipPayload } from 'types/interfaces/ITypes'

export const getProfile = async () => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/profile'
    })
    return data?.data
}

export const getPerformer = async (id: any) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/user/${id}/profile`
    })
    return data?.data
}
export const getPerformerByUsername = async (username: any) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/user/${username}/profile-data`
    })
    return data?.data
}

export const getFanDetails = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/user/analytic/fan/${id}`
    })
    return data?.data
}
export const getUserNotes = async (
  userPublicId: string
): Promise<UserNote[]> => {
  const { data } = await axiosInstance({
    method: 'GET',
    url: `/api/user/notes/${userPublicId}`
  })

  return data?.data
}
export const addUserNote = async (payload: NewNote) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/user/notes`,
        data: payload
    })
    return data?.data
}
export const viewProfile = async (
  profileId: string,
  isSubscribed: boolean
) => {
  const { data } = await axiosInstance({
    method: 'POST',
    url: '/api/profile/view',
    data: {
      profile_id: profileId,
      is_subscribed: isSubscribed
    }
  })

  return data?.data
}
export const deleteUserNote = async (id: number) => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/user/notes/${id}`
    })
    return data?.data
}

export const subscribeToUser = async ({
    id,
    subscription_plan_id,
    payment_method,
    card_id,
    promo_campaign_id,
    suggested,
    rebill,
    tax,
    tax_rate,
    storeCvc,
    cvc
}: SubscribePayload) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/subscription/${id}`,
        data: {
            subscription_plan_id,
            payment_method,
            card_id,
            promo_campaign_id,
            suggested,
            rebill,
            tax,
            tax_rate,
            storeCvc,
            cvc
        }
    })
    return data
}

export const sendTipToModel = async (payload: ITipPayload) => {
  const { model_id, ...data } = payload

  const { data: response } = await axiosInstance({
    method: 'POST',
    url: `/api/user/${model_id}/tip`,
    data
  })

  return response
}

export const putAvatarImage = async ({
    image,
    cropped_image
}: ImageAndCropImage) => {
    return await axiosInstance({
        method: 'PUT',
        url: '/api/user/change-avatar',
        data: {
            avatar: image,
            cropped_avatar: cropped_image
        }
    })
}

export const putCoverImage = async ({
    image,
    cropped_image
}: ImageAndCropImage) => {
    return await axiosInstance({
        method: 'PUT',
        url: '/api/user/change-cover',
        data: {
            cover: image,
            cropped_cover: cropped_image
        }
    })
}

export const putUserCountry = async (country_id: number) => {
    return await axiosInstance({
        method: 'PUT',
        url: '/api/user/country',
        data: { country_id }
    })
}

export const postModelVerification = async (userData: any) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/model-verification',
        data: userData
    })
    return data
}

export const postConfirmVerify = async (userId: string) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/admin/model-approve',
        data: {
            model_id: userId,
            action: 'approve'
        }
    })
    return data
}

export const deleteUser = async (params: {
    code: string
    delete_reason: string
}) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/delete-user',
        data: params
    })

    return data
}
export const deactivateUser = async (params: {
    code: string
    deactivate_reason: string
    status: string
}) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/deactivate-user',
        data: params
    })

    return data
}

export const sendDeleteCode = async (email? : any) => {
    console.log(email , 'ccnioecmnineior')
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/send-delete-code',
        data: {email : email}
    })

    return data
}

export const postSetGuideFirstSeen = async () => {
    return await axiosInstance({
        method: 'POST',
        url: '/api/user/first-tour'
    })
}

export const updateTwoFactorAuthType = async ({ type }: { type: string | null }) => {
    const response = await axiosInstance({
        method: 'POST',
        url: '/api/update-two-factor-auth',
        data: {
            two_factor_auth_type: type
        }
    })

    return response
}